import type { ApartmentAvailabilityItem } from '@/lib/apartments/apartmentsQuery'
import type { LocationCommunitySpaces } from '@/lib/locations/locationCommunitySpaces'

export const AVAILABILITY_SECTION_OMITTED_FIELDS = [
  'amenities',
  'amenityDetails',
  'bookingUrl',
  'communitySpaces',
  'content',
  'features',
  'galleryViews',
  'listingFilters',
  'popularChoice',
] as const

export type AvailabilitySectionOmittedField = (typeof AVAILABILITY_SECTION_OMITTED_FIELDS)[number]

export type AvailabilitySectionItem = Omit<ApartmentAvailabilityItem, AvailabilitySectionOmittedField>

export type AvailabilitySectionData = {
  apartments: AvailabilitySectionItem[]
  communitySpacesByLocation: Record<string, LocationCommunitySpaces>
}

function toSectionItem(item: ApartmentAvailabilityItem): AvailabilitySectionItem {
  const sectionItem = { ...item }

  for (const field of AVAILABILITY_SECTION_OMITTED_FIELDS) {
    delete sectionItem[field]
  }

  return sectionItem
}

export function toAvailabilitySectionData(
  items: ApartmentAvailabilityItem[],
): AvailabilitySectionData {
  const communitySpacesByLocation: Record<string, LocationCommunitySpaces> = {}

  const apartments = items.map((item) => {
    if (item.communitySpaces) {
      const locationKey = String(item.locationId)
      if (!communitySpacesByLocation[locationKey]) {
        communitySpacesByLocation[locationKey] = item.communitySpaces
      }
    }

    return toSectionItem(item)
  })

  return { apartments, communitySpacesByLocation }
}

export function communitySpacesForLocation(
  communitySpacesByLocation: Record<string, LocationCommunitySpaces>,
  locationId: number | null | undefined,
): LocationCommunitySpaces | null {
  if (locationId == null) return null
  return communitySpacesByLocation[String(locationId)] ?? null
}
